import { render } from "./MyPractice.vue?vue&type=template&id=4ee49cde&scoped=true"
import script from "./MyPractice.vue?vue&type=script&lang=js"
export * from "./MyPractice.vue?vue&type=script&lang=js"

import "./MyPractice.vue?vue&type=style&index=0&id=4ee49cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee49cde"]])

export default __exports__